var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shown)?_c('div',{staticClass:"current-ldap-value"},[_vm._v(" actuellement dans LDAP P1 : "+_vm._s(_vm.formattedLdapValue)+" "),(!_vm.opts_.readOnly)?_c('span',{staticClass:"glyphicon glyphicon-circle-arrow-up",attrs:{"title":"Utiliser la valeur actuelle du compte"},on:{"click":_vm.revert}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }